module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921110834_T.21d274b1.jpg";